export const FirebaseConfig = {
	"projectId": "pegasodelivery",
	"appId": "1:595916076524:web:e7dda7d5c4aedb6a027cc9",
	"databaseURL": "https://pegasodelivery-default-rtdb.firebaseio.com",
	"storageBucket": "pegasodelivery.firebasestorage.app",
	"apiKey": "AIzaSyByKA2PtKeR2E4eQ65QchR8Hyi5Cqh45X0",
	"authDomain": "pegasodelivery.firebaseapp.com",
	"messagingSenderId": "595916076524",
	"measurementId": "G-YLMZZYNYTG"
};